import React, { useEffect } from "react";
import { Button, Form, Modal } from "@themesberg/react-bootstrap";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

const RenderCustomIputs = (props) => {
  const { global_inputs, input_label, setGlobalInputs, new_label } = props;

  const [inputs, setInputs] = useState(global_inputs);
  const addInputField = () => {
    setInputs([...inputs, ""]);
    // setUpdate((prev) => prev + 1);
  };

  const handleInputChange = (index, event) => {
    const newInputs = inputs.map((input, i) =>
      i === index ? event.target.value : input
    );
    setInputs(newInputs);
    setGlobalInputs(newInputs);
  };
  const deleteInputField = (index) => {
    const newInputs = inputs.filter((_, i) => i !== index);
    setInputs(newInputs);
    setGlobalInputs(newInputs);
  };
  useEffect(() => {
    setGlobalInputs(inputs);
    console.log(inputs);
  }, inputs);
  return (
    <>
      {inputs &&
        inputs.map((input, index) => (
          <div key={index}>
            <Form.Group className="mb-2">
              <Form.Label>
                {" "}
                {input_label} : {index + 1}{" "}
              </Form.Label>
              <div className="d-flex justify-content-between">
                <Form.Control
                  className="me-2"
                  value={input}
                  onChange={(event) => handleInputChange(index, event)}
                ></Form.Control>
                {index > 0 && (
                  <FontAwesomeIcon
                    icon={faTimesCircle}
                    role="button"
                    className="text-orange"
                    onClick={() => deleteInputField(index)}
                  />
                )}
              </div>
            </Form.Group>
          </div>
        ))}
      <small
        role="button"
        className="text-main"
        onClick={() => addInputField()}
      >
        {new_label}{" "}
      </small>
    </>
  );
};

export default RenderCustomIputs;
